import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetBrandsbyIdQuery, useUpdateBrandsMutation } from "../../Services/BrandsAPI";
import { useNavigate, useParams } from "react-router-dom";


function AddCategory() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [categoryName, setCategoryName] = useState("");
    const [categoryImage, setCategoryImage] = useState(null);

    const [description, setDescription] = useState("");
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);

    const [updateCategory, { isLoading }] = useUpdateBrandsMutation();
    const { data: categoryDetail, isLoading: loadingContent, error, refetch: refetchCategoryDetail } = useGetBrandsbyIdQuery(id);


    useEffect(() => {
        refetchCategoryDetail();
    }, [refetchCategoryDetail])

    useEffect(() => {
        console.log("categoryDetail", categoryDetail)
        setCategoryName(categoryDetail?.brand?.name);
        setDescription(categoryDetail?.brand?.description);
    }, [categoryDetail])

    const validateForm = () => {
        let newErrors = {};
        if (!categoryName.trim()) newErrors.categoryName = "Brand Name is required";
        
     
        if (!description.trim()) newErrors.description = "Description is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return; 

        const formData = new FormData();
        formData.append("name", categoryName);
        if (categoryImage) {
            formData.append("image", categoryImage);
        }

        formData.append("description", description);
        try {
            await updateCategory({ formData, id }).unwrap();
            alert("Updated successfully!");
            // Reset form fields
            setCategoryName("");
            setCategoryImage(null);
            setDescription("");
            setErrors({});

            setApiError(null);
            navigate("/list-brands")
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Edit Brands</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/list-brands"><span>Brands</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Edit</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        {/* Category Name */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_name" className="form-label">Brand Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="category_name"
                                    placeholder="Enter Category Name"
                                    value={categoryName}
                                    onChange={(e) => setCategoryName(e.target.value)}
                                />
                                {errors.categoryName && <p className="text-danger">{errors.categoryName}</p>}
                            </div>
                        </div>


                        {/* Description */}
                        <div className="col-md-12 col-sm-12 col-lg-12">
                            <div className="mb-4 text-start">
                                <label htmlFor="description" className="form-label w-100">Description</label><br />
                                <textarea
                                    rows={4}
                                    name="description"
                                    className="form-control"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                {errors.description && <p className="text-danger">{errors.description}</p>}
                            </div>
                        </div>

                        {/* Category Image */}
                        <div className="col-md-6 col-sm-12 col-lg-6 d-block">
                            <div className="text-start">
                                <label htmlFor="category_image" className="form-label">Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="category_image"
                                    onChange={(e) => setCategoryImage(e.target.files[0])}
                                />
                            </div>
                            <img src={categoryDetail?.brand?.image} className="category-edit-img" alt="category-img" />
                        </div>

                    </div>



                    {/* API Error Message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
